c3site.forms = {
    'load': function(form_name, product_id){
        $.ajax({
            type: "GET",
            url: cyclone3.domain + '/' + cyclone3.lng + '/chunk/form/' + form_name,
            success: function(data)
            {
                try {
                    var form = $(data).find('.form_popup');
                    $("body").append(form);
                } catch(e) {
                    alert(e);
                }                    
            }
        });
    },
    'close': function(form_name){
        var form = $("#form_" + form_name);
        $("body").removeClass("form_popup_open");
        form.hide();
        c3site.forms.reset(form);        
    },	
    'reset': function(form){
        form.find('input:text, input:password, select, textarea').val('');
        form.find('input[type="number"]').val('');
        form.find('input:radio, input:checkbox').removeAttr('checked').removeAttr('selected');
        form.find('label.label_check').removeClass('c_on');
        form.find('.form_popup_content').show();
        form.find('label.label_check').removeClass('c_on');
        form.find('.alert').hide();
        form.find('.has-error').removeClass('has-error');
        form.find('.has-error-input').removeClass('has-error-input');
        form.find('.has-error-checkbox').removeClass('has-error-checkbox');
        form.find('input[name="email"]').val(c3site.forms.email);
    	form.find(".successnotice").hide();
    	form.find(".form_popup_content").show();
    	form.find("input:checkbox").prop('checked', false);
        form.find(".addedDescription").empty();
            
    },
    'params': {
        'validate': function(form, requiredParams){
            var failed=false;
            form.find('.has-error-input').removeClass('has-error-input');
            form.find('.has-error-checkbox').removeClass('has-error-checkbox');
            form.find('.has-error').removeClass('has-error');
            form.find('.errornotice').hide();
			var isEmail = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/,
                loadingIcon = '<i class="fa fa-cog fa-spin fa-3x fa-fw"></i>';
            $.each( requiredParams, function( name, type ) {
                if (type == "email") {
					if (!isEmail.test(form.find("input[name='"+name+"']").val())) {
                        var elem = form.find("input[name='"+name+"']");
                        elem.addClass("has-error-input");
                        form.find('label[for='+  elem.attr('id')  +']').addClass("has-error");
                        failed=true;
                    }
                }
                if (type == "text") {
                    if(!form.find("input[name='"+name+"']").val()) {
                        var elem = form.find("input[name='"+name+"']");
                        elem.addClass("has-error-input");
                        form.find('label[for='+  elem.attr('id')  +']').addClass("has-error");
                        failed=true;
                    }
                }
                if (type == "phone") {
                    if(!form.find("input[name='"+name+"']").val()) {
                        var elem = form.find("input[name='"+name+"']");
                        elem.addClass("has-error-input");
                        form.find('label[for='+  elem.attr('id')  +']').addClass("has-error");
                        failed=true;
                    }
                }
                if (type == "checkbox") {
                    if(!form.find("input[name='"+name+"']").is(":checked")) {
                        var elem = form.find("input[name='"+name+"']");
                        elem.addClass("has-error-checkbox");
                        form.find('label[for='+  elem.attr('id')  +']').addClass("has-error");
                        failed=true;
                    }   
                }
                if (type == "textarea") {
                    if(!form.find("textarea[name='"+name+"']").val()) {
                        var elem = form.find("textarea[name='"+name+"']");
                        elem.addClass("has-error-input");
                        form.find('label[for='+  elem.attr('id')  +']').addClass("has-error");
                        failed=true;
                    }   
                }
                if (type == "select") {
                    if(!form.find("select[name='"+name+"']").val()) {
                        var elem = form.find("select[name='"+name+"']");
                        elem.addClass("has-error-input");
                        form.find('label[for='+  elem.attr('id')  +']').addClass("has-error");
                        failed=true;
                    }   
                }
            });
            return failed;
        },
        'process': function(form, params){
            var dataSet = {};                    
            $.each( params, function( name, type ) {
                var value ="";                
                if (type == "email") {
                    value = form.find("input[name='"+name+"']").val();
                }
                if (type == "text") {
                    value = form.find("input[name='"+name+"']").val()
                }
                if (type == "checkbox") {
                    value = form.find("input[name='"+name+"']").val();
                }                
                if (type == "radio") {
                    value = form.find("input[name='"+name+"']:checked").val();
                }
                if (type == "select") {
                    value = form.find("select[name='"+name+"'] option:selected").val()
                }
                if (type == "textarea") {
                    value = form.find("textarea[name='"+name+"']").val()
                }
                if (type == "hidden") {
                    value = form.find("input[name='"+name+"']").val()
                }
                dataSet[name] = value;                
            });
            return dataSet;
        },	
    },		
    'process_result': function(form, data) {
        var tmpResultCode = data.result;
        if(tmpResultCode <= 0)
        {
            if (data.errors != "") {
                form.find('.errornotice').empty().html(data.errors);            
			}
            form.find('.errornotice').slideDown('fast');
            
        }
        else
        {
            form.find(".form_popup_content").hide();
            form.find(".form_send").hide();
            form.find(".successnotice").show();
        }
    },
    'ask_question': {
        'send': function(form_name){
            var form = $( "#form_" + form_name);
            var product;
            var ID = form.data("product-id");
            if ($(".product-list-item[data-id='" + ID + "']").length) {
                product = $(".product-list-item[data-id='" + ID + "']");            
            }
            if ($(".product-detail[data-id='" + ID + "']").length) {
                product = $(".product-detail[data-id='" + ID + "']");
            }
            
            var params = {};
            params["question"] = "textarea";
            params["email"] = "email"; 
            
            var failed = c3site.forms.params.validate(form, params);
            
            if(!failed)
            {
                form.find("button").addClass("loading");
                var dataSet = c3site.forms.params.process(form, params);
                dataSet['domain'] = cyclone3.domain;
                dataSet['idproduct'] = product.data("id");
                dataSet['product'] = encodeURIComponent(product.data("name"));
            
                $.ajax({
                    type: "GET",
                    dataType: 'json',
                    url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/product_forms/'+form_name,
                    data: dataSet,
                    success: function(data) {
                        console.log(form,data);
                        c3site.forms.process_result(form, data);
                        form.find("button").removeClass("loading");
                    }
                });          
            }
        }
    },
    'watchdog_stock': {
        'send': function(form_name){
            var form = $( "#form_" + form_name);
            var product;
            var ID = form.data("product-id");
            if ($(".product-list-item[data-id='" + ID + "']").length) {
                product = $(".product-list-item[data-id='" + ID + "']");            
            }
            if ($(".product-detail[data-id='" + ID + "']").length) {
                product = $(".product-detail[data-id='" + ID + "']");
            }
            var params = {};
            params["in_stock"] = "checkbox";
            params["email"] = "email"; 
            
            var failed = c3site.forms.params.validate(form, params);
            if(!failed)
            {
                form.find("button").addClass("loading");
                params["user"] = "hidden"; 
                var dataSet = c3site.forms.params.process(form, params);
                dataSet['domain'] = cyclone3.domain;
                dataSet['idproduct'] = product.data("id");
                dataSet['product'] = encodeURIComponent(product.data("product-name"));
            
                $.ajax({
                    type: "GET",
                    dataType: 'json',
                    url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/product_forms/'+form_name,
                    data: dataSet,
                    success: function(data) {
                        c3site.forms.process_result(form, data);
                        form.find("button").removeClass("loading");
                    }
                });          
            }
        }
    },	
    'watchdog_price': {
        'send': function(form_name){
            var form = $( "#form_" + form_name);
            var product;
            var ID = form.data("product-id");
            if ($(".product-list-item[data-id='" + ID + "']").length) {
                product = $(".product-list-item[data-id='" + ID + "']");            
            }
            if ($(".product-detail[data-id='" + ID + "']").length) {
                product = $(".product-detail[data-id='" + ID + "']");
            }
                        
            var params = {};
            params["price"] = "text";
            params["email"] = "email"; 
            
            var failed = c3site.forms.params.validate(form, params);
            
            if(!failed)
            {
                form.find("button").addClass("loading");
                params["user"] = "hidden"; 
                params["lvl"] = "hidden";
                var dataSet = c3site.forms.params.process(form, params);
                dataSet['domain'] = cyclone3.domain;
                dataSet['idproduct'] = product.data("id");
                dataSet['product'] = encodeURIComponent(product.data("product-name"));

                $.ajax({
                    type: "GET",
                    dataType: 'json',
                    url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/product_forms/'+form_name,
                    data: dataSet,
                    success: function(data) {
                        c3site.forms.process_result(form, data);
                        form.find("button").removeClass("loading");
                    }
                });          
            }
        }
    },
    'newsletter_subscribe': {
        'send': function(form_name){
            var form = $( "#form_" + form_name);
            
            var params = {};
            params["email"] = "email"; 
            
            var dataSet = c3site.forms.params.process(form, params);
            dataSet['domain'] = cyclone3.domain;

            var checkbox = form.find('.checkbox');
            var checkboxInput = form.find('.checkbox input')
            checkbox.removeClass('has-error');

            if ($(checkboxInput).is(':checked')) {
                form.find("button").addClass("loading");
                $.ajax({
                    type: "GET",
                    dataType: 'json',
                    url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/newsletter/subscribe',
                    data: dataSet,
                    success: function(data) {
                        if( data.success != true)
                        {
                            form.find('.errornotice').text(data.errors);
                            form.find('.errornotice').slideDown('fast');
                        }
                        else
                        {
                            form.find(".input-group").hide();                            
                            form.find('.successnotice').text(data.result);
                            form.find('.successnotice').slideDown('fast');
                        }
                        form.find("button").removeClass("loading");
                    }
                });
            } else {
                checkbox.addClass('has-error');
            }
        }
    }
};

$(document).ready(function(){
    $(document).on('click', '.open_popup', function(evt) {
        var form = $( "#form_" + $( this ).data("target"));
        c3site.forms.reset(form);
        $(".form_popup").each(function(){
            $( this ).hide();
        });
        
        var ID = $( this ).data("product-id");
        if (ID) {
        form.data("product-id", $( this ).data("product-id"));
            var product;
            if ($(".product-list-item[data-id='" + ID + "']").length) {
                product = $(".product-list-item[data-id='" + ID + "']");            
            }
            if ($(".product-detail[data-id='" + ID + "']").length) {
                product = $(".product-detail[data-id='" + ID + "']");
            }
            if ($( this ).data("target") == "ask_question") {                
                form.find(".description").append("<p>"+ product.data("product-name") + "</p>");
                form.find(".description").addClass("addedDescription");
            }
        }
        
        $("body").addClass("form_popup_open");
        form.fadeIn();
        
        cyclone3.cancelEvent(evt);
        evt.stopPropagation();    	
    });
    
    $( ".form_send.btn" ).on( "click", function(evt) {
        var form = $( this ).data("target")
        if (form != "") {
            switch(form) {
                case "ask_question":
                    c3site.forms.ask_question.send(form);
                    break;
                case "watchdog_stock":
                    c3site.forms.watchdog_stock.send(form);
                    break;
                case "watchdog_price":
                    c3site.forms.watchdog_price.send(form);
                    break;
            }
        }
        cyclone3.cancelEvent(evt);
        evt.stopPropagation();    	
    });
    
    $( ".close_popup" ).on( "click", function(evt) {
        var form = $( this ).closest(".form_popup").data("form-name");
        c3site.forms.close(form);
    });
    
    
    $( "#newsletter_subscribe" ).on( "click", function(evt) {
        c3site.forms.newsletter_subscribe.send("newsletter_subscribe");
        cyclone3.cancelEvent(evt);
        evt.stopPropagation();    	
    });
    
    
});